export default __webpack_public_path__ + "static/media/Sgb.139eb1b5.png";